import { Component, OnInit, inject } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { HrefDirective } from '../../../directives/href/href.directive';
import { IconComponent } from '../../../components/icon/icon.component';
import { SecurityService } from '../../../services/security.service';
/**
 * Search Navigation Component
 *
 * This is the search navigation for Menu Component, it holds the search
 */
@Component({
  selector: 'td-wb-menu-search-navigation',
  templateUrl: 'search-navigation.component.html',
  styleUrls: ['search-navigation.component.scss'],
  imports: [
    TranslateDirective,
    HrefDirective,
    IconComponent,
    TranslatePipe
  ]
})
export class MenuSearchNavigationComponent implements OnInit {
  private readonly securityService = inject(SecurityService);

  searchPermission: boolean;

  ngOnInit(): void {
    this.searchPermission = this.securityService.hasPermission('SEARCH');
  }
}
